var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@emotion/css';
import { Box, tokens } from '@vp/swan';
const modalBodyStyles = css `
    && {
        flex: 1;
        height: 100%;
        overflow: auto;

        padding: ${tokens.SwanSemSpace2} ${tokens.SwanSemSpace5};
        margin: 0 calc(-1 * ${tokens.SwanSemSpace5});

        @media ${tokens.SwanSemMqGteSm.replace(/'/gi, '')} {
            padding: ${tokens.SwanSemSpace2} ${tokens.SwanSemSpace10};
            margin: 0 calc(-1 * ${tokens.SwanSemSpace10});
        }
    }
`;
export const StudioModalBody = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (_jsx(Box, Object.assign({ className: modalBodyStyles }, rest, { children: children })));
};
//# sourceMappingURL=StudioModalBody.js.map